import Dropdown from "components/dropdown/Dropdown";
import { captureEvent } from "components/posthog/customEventCapture";

import "./InventoryCreator.scss";

export type Option = {
  label: string;
  value: string;
};
type Props = {
  onCreate: () => void;
  onYearChange: (option: Option) => void;
  isDisabled: boolean;
  selectedYear: string | null;
  years: string[];
};

export default function InventoryCreator({
  onCreate,
  onYearChange,
  isDisabled,
  selectedYear,
  years
}: Props) {
  const options = years.map((year) => {
    return {
      label: year,
      value: year
    };
  });

  return (
    <div>
      <h3>Skapa inventeringsformulär avseende räkenskapsår</h3>

      <div className="create">
        <Dropdown
          isClearable={false}
          options={options}
          className="selectsm"
          value={selectedYear?.toString()}
          onChange={(selected) => {
            if (selected && !Array.isArray(selected)) {
              const selectedOption = selected as {
                value: string;
                label: string;
              };
              onYearChange(selectedOption); // Pass the value of the selected option
            }
          }}
        />
        <button
          className="createButton"
          disabled={isDisabled}
          onClick={() => {
            onCreate();
            captureEvent("Skapa");
          }}
        >
          Skapa
        </button>
      </div>
    </div>
  );
}
